import { TranslationString } from 'shared/entities/localization';
import { SelectorEntities } from 'shared/entities/components/Selector';

import { IList } from '../list';
import { IUserAttachmentVar, IUserCommonVar, IUserDateVar } from '../vars';
import { BlockNormalized } from '../block/client';
import { Bucket } from '../bucket';
import { ChannelKindType } from '../channels';
import { IUserNote } from '../userNote';

export interface IUserProfile {
  id: string;
  userName: string;
  firstName: string;
  lastName: string;
  email: string | null;
  phone: string | null;
}

export interface IUserItem extends IUserProfile {
  photoUrl: string | null;
  channelKind: ChannelKindType;
  channelId: string;
  externalId: string;
  url: string | null;
  vars: IList<IUserAttachmentVar | IUserCommonVar | IUserDateVar>;
  notes: IUserNote[];
  unreadMentionNoteIds: Set<string>;
}

export interface IPlannedEvent {
  id: string;
  block: BlockNormalized;
  date: Date;
  bucket: Bucket;
}

export const USERS_ALL_SELECTOR_ID = '__ALL_USERS__';

export const mapUsersAllEntity: Record<
  string,
  { id: string; title: TranslationString }
> = {
  [USERS_ALL_SELECTOR_ID]: {
    id: USERS_ALL_SELECTOR_ID,
    title: (t) =>
      t('usersList.allUserTitle', {
        ns: 'entities'
      })
  }
};

export enum UsersFileType {
  xlsx = 'xlsx',
  csv = 'csv',
  txt = 'txt'
}

export const USER_LIST_UNSUBSCRIBED_TAG = 'unsubscribed';

export const mapFileTypeToExtensions = {
  [UsersFileType.xlsx]: ['xlsx'],
  [UsersFileType.csv]: ['csv'],
  [UsersFileType.txt]: ['txt']
};

export const orderUsersFileType: UsersFileType[] = [
  UsersFileType.xlsx,
  UsersFileType.csv,
  UsersFileType.txt
];

export const entitiesUsersFileType = orderUsersFileType.reduce<
  SelectorEntities<UsersFileType>
>(
  (acc, type) => ({
    ...acc,
    [type]: {
      id: type,
      title: (t) =>
        t(`usersList.${type}`, {
          ns: 'entities'
        })
    }
  }),
  {} as SelectorEntities<UsersFileType>
);
